/**
 * Villa Glory Materials Library — category landing + detail views
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-vg-material-library]');
  if (!root) return;

  var dataUrlEl = document.getElementById('vg-materials-data-url');
  var configEl = document.getElementById('vg-materials-config');
  var dataUrl = dataUrlEl ? JSON.parse(dataUrlEl.textContent) : null;
  var config = configEl ? JSON.parse(configEl.textContent) : { placeholderImage: '' };

  var categoriesView = root.querySelector('[data-vg-ml-view="categories"]');
  var detailView = root.querySelector('[data-vg-ml-view="detail"]');
  var categoriesEl = root.querySelector('[data-vg-ml-categories]');
  var detailHeader = root.querySelector('[data-vg-ml-detail-header]');
  var filtersEl = root.querySelector('[data-vg-ml-filters]');
  var searchInput = root.querySelector('[data-vg-ml-search]');
  var grid = root.querySelector('[data-vg-ml-grid]');
  var countEl = root.querySelector('[data-vg-ml-count]');
  var emptyEl = root.querySelector('[data-vg-ml-empty]');
  var backBtn = root.querySelector('[data-vg-ml-back]');
  var categorySelect = root.querySelector('[data-vg-ml-category-select]');
  var messageField = root.querySelector('[data-vg-ml-message]');

  var state = {
    data: null,
    categorySlug: null,
    search: '',
    filters: { tone: '', finish: '', application: '' },
  };

  var imageObserver = null;

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function imageUrl(path) {
    if (!path) return config.placeholderImage;
    if (config.assetsBase) {
      var flat = path.replace(/\//g, '-');
      var base = config.assetsBase;
      var cut = base.length;
      var qi = base.indexOf('?');
      var hi = base.indexOf('#');
      if (qi >= 0) cut = Math.min(cut, qi);
      if (hi >= 0) cut = Math.min(cut, hi);
      var pathOnly = base.slice(0, cut);
      var suffix = base.slice(cut);
      return pathOnly.replace(/[^/]+$/, flat) + suffix;
    }
    return config.placeholderImage;
  }

  function setupLazyImages(container) {
    if (!('IntersectionObserver' in window)) {
      container.querySelectorAll('img[data-src]').forEach(function (img) {
        img.src = img.getAttribute('data-src') || config.placeholderImage;
      });
      return;
    }

    if (!imageObserver) {
      imageObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var img = entry.target;
            var src = img.getAttribute('data-src');
            if (src) {
              img.src = src;
              img.removeAttribute('data-src');
            }
            img.onerror = function () {
              img.src = config.placeholderImage;
              img.classList.add('is-placeholder');
            };
            imageObserver.unobserve(img);
          });
        },
        { rootMargin: '120px' }
      );
    }

    container.querySelectorAll('img[data-src]').forEach(function (img) {
      imageObserver.observe(img);
    });
  }

  function getCategory(slug) {
    if (!state.data) return null;
    return state.data.categories.find(function (c) {
      return c.categorySlug === slug;
    });
  }

  function showView(view) {
    var isDetail = view === 'detail';
    if (categoriesView) categoriesView.hidden = isDetail;
    if (detailView) detailView.hidden = !isDetail;
    root.classList.toggle('is-detail', isDetail);
  }

  function openCategory(slug, pushState) {
    var cat = getCategory(slug);
    if (!cat) return;

    state.categorySlug = slug;
    state.search = '';
    state.filters = { tone: '', finish: '', application: '' };

    if (searchInput) searchInput.value = '';
    renderFilters();
    renderDetailHeader(cat);
    renderGrid();

    showView('detail');

    if (pushState !== false) {
      var url = slug ? '#category-' + slug : window.location.pathname;
      history.pushState({ category: slug }, '', url);
    }

    if (detailView) {
      detailView.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function closeCategory(pushState) {
    state.categorySlug = null;
    showView('categories');

    if (pushState !== false) {
      history.pushState({ category: null }, '', window.location.pathname);
    }

    if (categoriesView) {
      categoriesView.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function renderCategories() {
    if (!categoriesEl || !state.data) return;

    categoriesEl.innerHTML = state.data.categories
      .map(function (cat) {
        return (
          '<article class="vg-ml-cat-card" role="listitem">' +
          '<button type="button" class="vg-ml-cat-card__btn" data-vg-ml-open-cat="' +
          esc(cat.categorySlug) +
          '" aria-label="Explore ' +
          esc(cat.categoryName) +
          ' collection">' +
          '<div class="vg-ml-cat-card__media">' +
          '<img src="' +
          esc(config.placeholderImage) +
          '" data-src="' +
          esc(imageUrl(cat.heroImage)) +
          '" alt="' +
          esc(cat.categoryName) +
          ' — material category" loading="lazy" width="640" height="640">' +
          '<div class="vg-ml-cat-card__overlay"></div>' +
          '</div>' +
          '<div class="vg-ml-cat-card__body">' +
          '<h3 class="vg-ml-cat-card__title">' +
          esc(cat.categoryName) +
          '</h3>' +
          '<p class="vg-ml-cat-card__desc">' +
          esc(cat.description) +
          '</p>' +
          '<p class="vg-ml-cat-card__count">' +
          cat.items.length +
          ' finishes</p>' +
          '<span class="vg-ml-cat-card__cta">Explore Collection</span>' +
          '</div></button></article>'
        );
      })
      .join('');

    setupLazyImages(categoriesEl);

    categoriesEl.querySelectorAll('[data-vg-ml-open-cat]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openCategory(btn.getAttribute('data-vg-ml-open-cat'));
      });
    });
  }

  function renderDetailHeader(cat) {
    if (!detailHeader) return;
    detailHeader.innerHTML =
      '<h2 class="vg-ml-detail-header__title">' +
      esc(cat.categoryName) +
      '</h2>' +
      '<p class="vg-ml-detail-header__desc">' +
      esc(cat.description) +
      '</p>';
  }

  function renderFilters() {
    if (!filtersEl || !state.data) return;
    var f = state.data.filters;

    function group(label, key, options) {
      var html =
        '<fieldset class="vg-ml-filter-group">' +
        '<legend class="vg-ml-filter-group__label">' +
        esc(label) +
        '</legend><div class="vg-ml-filter-group__options">';
      html +=
        '<button type="button" class="vg-ml-filter-btn' +
        (state.filters[key] === '' ? ' is-active' : '') +
        '" data-vg-ml-filter="' +
        key +
        '" data-vg-ml-filter-value="">All</button>';
      options.forEach(function (opt) {
        html +=
          '<button type="button" class="vg-ml-filter-btn' +
          (state.filters[key] === opt ? ' is-active' : '') +
          '" data-vg-ml-filter="' +
          key +
          '" data-vg-ml-filter-value="' +
          esc(opt) +
          '">' +
          esc(opt) +
          '</button>';
      });
      html += '</div></fieldset>';
      return html;
    }

    filtersEl.innerHTML =
      group('Tone', 'tone', f.tones) +
      group('Finish', 'finish', f.finishes) +
      group('Application', 'application', f.applications);

    filtersEl.querySelectorAll('[data-vg-ml-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-vg-ml-filter');
        state.filters[key] = btn.getAttribute('data-vg-ml-filter-value') || '';
        renderFilters();
        renderGrid();
      });
    });
  }

  function filterItems(items) {
    var q = state.search.trim().toLowerCase();
    return items.filter(function (item) {
      if (q && item.name.toLowerCase().indexOf(q) === -1 && item.description.toLowerCase().indexOf(q) === -1) {
        return false;
      }
      if (state.filters.tone && item.tone !== state.filters.tone) return false;
      if (state.filters.finish && item.finish !== state.filters.finish) return false;
      if (state.filters.application && item.applications.indexOf(state.filters.application) === -1) return false;
      return true;
    });
  }

  function renderGrid() {
    if (!grid || !state.data) return;
    var cat = getCategory(state.categorySlug);
    if (!cat) return;

    var items = filterItems(cat.items);

    if (countEl) {
      countEl.textContent = items.length + ' of ' + cat.items.length + ' finishes';
    }
    if (emptyEl) emptyEl.hidden = items.length > 0;
    grid.hidden = items.length === 0;

    grid.innerHTML = items
      .map(function (item) {
        var apps = item.applications
          .map(function (a) {
            return '<span class="vg-ml-card__app">' + esc(a) + '</span>';
          })
          .join('');

        return (
          '<article class="vg-ml-card" role="listitem" data-material-slug="' +
          esc(item.slug) +
          '">' +
          '<div class="vg-ml-card__media">' +
          '<img src="' +
          esc(config.placeholderImage) +
          '" data-src="' +
          esc(imageUrl(item.image)) +
          '" alt="' +
          esc(item.name) +
          ' — ' +
          esc(cat.categoryName) +
          ' swatch" loading="lazy" width="512" height="512">' +
          '</div>' +
          '<div class="vg-ml-card__body">' +
          '<p class="vg-ml-card__category">' +
          esc(cat.categoryName) +
          '</p>' +
          '<h3 class="vg-ml-card__title">' +
          esc(item.name) +
          '</h3>' +
          '<div class="vg-ml-card__meta">' +
          '<span class="vg-ml-card__meta-item"><span>Finish</span> ' +
          esc(item.finish) +
          '</span>' +
          '<span class="vg-ml-card__meta-item"><span>Tone</span> ' +
          esc(item.tone) +
          '</span>' +
          '</div>' +
          '<div class="vg-ml-card__apps">' +
          apps +
          '</div>' +
          '<p class="vg-ml-card__desc">' +
          esc(item.description) +
          '</p>' +
          '<button type="button" class="vg-btn vg-btn--outline vg-ml-card__cta" data-vg-ml-request="' +
          esc(item.slug) +
          '">Request Sample</button>' +
          '</div></article>'
        );
      })
      .join('');

    setupLazyImages(grid);

    grid.querySelectorAll('[data-vg-ml-request]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var slug = btn.getAttribute('data-vg-ml-request');
        var item = cat.items.find(function (x) {
          return x.slug === slug;
        });
        if (!item) return;

        if (categorySelect) categorySelect.value = cat.categoryName;
        if (messageField) {
          messageField.value =
            'Material sample request: ' +
            item.name +
            ' (' +
            cat.categoryName +
            ')\nFinish: ' +
            item.finish +
            '\nTone: ' +
            item.tone +
            '\n\nProject details:\n';
        }

        var form = document.getElementById(config.contactFormId || 'vg-material-library-form');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function parseHash() {
    var hash = window.location.hash.replace(/^#/, '');
    if (hash.indexOf('category-') === 0) {
      return hash.replace('category-', '');
    }
    return null;
  }

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      closeCategory();
    });
  }

  if (searchInput) {
    searchInput.addEventListener(
      'input',
      function () {
        state.search = searchInput.value;
        renderGrid();
      },
      { passive: true }
    );
  }

  window.addEventListener('popstate', function () {
    var slug = parseHash();
    if (slug) {
      openCategory(slug, false);
    } else {
      closeCategory(false);
    }
  });

  if (!dataUrl) return;

  fetch(dataUrl)
    .then(function (r) {
      if (!r.ok) throw new Error('fetch failed');
      return r.json();
    })
    .then(function (data) {
      state.data = data;
      renderCategories();
      renderFilters();

      var slug = parseHash();
      if (slug && getCategory(slug)) {
        openCategory(slug, false);
      } else {
        showView('categories');
      }
    })
    .catch(function () {
      if (categoriesEl) {
        categoriesEl.innerHTML = '<p class="vg-ml-error">Unable to load materials library.</p>';
      }
    });
})();
